/* src/components/tutor/tutor_announcements/dashboard/TutorAnnouncementCard.js */
import React, { useEffect, useState } from "react";
import { subscribeMyReadStatus } from "../TutorAnnouncementsLogic";
import { FiUsers } from "react-icons/fi";
import { BsPinFill } from "react-icons/bs";
import "./TutorAnnouncementCard.css";

function fmtDate(ms) {
  if (!ms) return "";
  const d = new Date(ms);
  return (
    d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) +
    " at " +
    d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })
  );
}

function safeCategory(cat) {
  return (cat || "").trim() || "General";
}

export default function TutorAnnouncementCard({ announcement, onOpenPost, onToast }) {
  const [myReadStatus, setMyReadStatus] = useState(null);

  useEffect(() => {
    const unsub = subscribeMyReadStatus(announcement.id, (status) => setMyReadStatus(status));
    return () => unsub?.();
  }, [announcement.id]);

  const createdAtMs =
    announcement.createdAtMs ||
    (announcement.createdAt && typeof announcement.createdAt.toMillis === "function"
      ? announcement.createdAt.toMillis()
      : null);

  const audienceLabel =
    announcement.audienceType === "all"
      ? "All Tutors"
      : `${(announcement.audienceUserIds || []).length} Tutors`;

  return (
    <div className={`taaCard ${!myReadStatus ? "unread" : ""}`} onClick={onOpenPost}>
      {/* Title row */}
      <div className="taaCardTitleRow">
        <div className="taaCardTitleLeft">
          {announcement.pinned && <BsPinFill size={12} className="taaCardPinIcon" />}
          {!myReadStatus && <span className="taaUnreadDot" />}
          <span className="taaCardTitle">{announcement.title || "(Untitled)"}</span>
        </div>
      </div>

      {/* Meta row */}
      <div className="taaCardMeta">
        <span className="taaCardCatTag">{safeCategory(announcement.category)}</span>
        <span className="taaCardMetaDot">·</span>
        <span>{announcement.createdByName || "Admin"}</span>
        <span className="taaCardMetaDot">·</span>
        <span>{fmtDate(createdAtMs)}</span>
        <span className="taaCardMetaDot">·</span>
        <span className="taaCardMetaAudience">
          <FiUsers size={12} /> {audienceLabel}
        </span>
      </div>

      {/* Preview */}
      <div
        className="taaCardPreview"
        dangerouslySetInnerHTML={{ __html: announcement.contentHtml || "" }}
      />
    </div>
  );
}
